import TransactionsTableItemDetails from './TransactionsTableItemDetails'

export default TransactionsTableItemDetails
